import { Box, Grid, Stack, Typography, Collapse, IconButton } from "@mui/material";
import { useContext, useState } from "react";
import { AiOutlineDashboard } from "react-icons/ai";
import { BiSupport } from "react-icons/bi";
import { BsPersonVideo } from "react-icons/bs";
import { FaAddressBook, FaChevronUp, FaMicrophone, FaChevronDown, FaLink } from "react-icons/fa";
import { FaImage, FaQuora } from "react-icons/fa6";
import { HiMiniVideoCamera } from "react-icons/hi2";
import { IoSettings } from "react-icons/io5";

import { MdVideoLibrary } from "react-icons/md";
import { RiChatPollFill } from "react-icons/ri";
import { SiPagespeedinsights, SiGoogleanalytics } from "react-icons/si";
import { TbCategoryFilled, TbNotification } from "react-icons/tb";
import { useLocation, useNavigate } from "react-router-dom";
import LogoWhite from "../assets/images/theTeacherAppLogo.svg";
import LogoWhiteMobile from "../assets/icons/favicon.ico";
import { ThemeContext } from "../context/ThemeContext";
import Style from "../styles/drawer.module.scss";
import { AuthContext } from "../context/AuthContext";
import { styled } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  // justifyContent: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const routePermissionModules = {
  "/user-management": ["users"],
  "/courses": ["courses"],
  "/short-videos": ["short_videos"],
  "/podcasts": ["podcast", "podcasts"],
  "/webinars": ["webinar", "webinars"],
  "/sunday-polls": ["polls", "sunday_polls"],
  "/quizzes": ["quizzes"],
  "/impact-stories-management": ["impact_story", "impact_stories"],
  "/competition": ["competition"],
  "/events": ["event", "events"],
  "/manage-post": ["teacher_lounge"],
  "/manage-flagged-post": ["teacher_lounge"],
  "/report-reason": ["teacher_lounge"],
  "/teaching-videos": ["teaching_resources", "teaching_videos"],
  "/school-resource": ["integrated_school_process", "school_process"],
  "/pbl-management": ["pbl"],
  "/tlm-management": ["tlm"],
  "/question-bank": ["question_bank"],
  "/notification-cohort-management": ["notifications"],
  "/channel-list": ["channel"],
  "/channel-banner": ["channel"],
  "/teacher-servey": ["survey"],
  "/get-analytics": ["analytics_dashboard", "analytics"],
  "/role-management": ["roles:read"],
  "/notifications": ["notifications"],
  "/holiday-homework-management": ["home_work"],
  "/entry-exit-management": ["entry_exit"],
  "/worksheet-management": ["worksheet"],
  "/lesson-plan-management": ["lesson_plan"],
  "/no-bag-activity-management": ["no_bag_activity"],
  "/check-your-understanding-management": ["check_your_understanding"],
  "/misconception-management": ["misconception"],
  "/action-research-management": ["action_research"],
  "/partners-management": ["partner"],
  "/quick-access": ["quick_access"],
};

const getPermissionAccess = (userData) => {
  const roles = Array.isArray(userData?.roles) ? userData.roles : [];

  return roles.reduce((modules, role) => {
    const permissions = Array.isArray(role?.permissions) ? role.permissions : [];

    permissions.forEach((permission) => {
      const module = permission?.module;
      if (!module) {
        return;
      }

      if (!modules.has(module)) {
        modules.set(module, new Set());
      }

      const moduleActions = modules.get(module);
      const codename = permission?.codename;

      if (codename) {
        moduleActions.add(codename);

        if (codename.includes(":")) {
          moduleActions.add(codename.split(":").pop());
        }
      }
    });

    return modules;
  }, new Map());
};

const hasRoutePermission = (route, permissionAccess) => {
  if (route?.main_routes === "Home") {
    return true;
  }

  const allowedModules = routePermissionModules[route?.link] || [];
  return allowedModules.some((allowedPermission) => {
    const [module, action = "read"] = allowedPermission.split(":");
    const moduleActions = permissionAccess.get(module);

    if (!moduleActions) {
      return false;
    }

    return (
      moduleActions.has(action) ||
      moduleActions.has(`${module}:${action}`) ||
      (action === "read" && moduleActions.has("read"))
    );
  });
};

const filterNavigationsByPermissions = (navigations, userData) => {
  if (!userData?.is_subadmin || userData?.is_superuser) {
    return navigations;
  }

  const permissionAccess = getPermissionAccess(userData);

  return navigations.reduce((allowedNavigations, navigation) => {
    const route = navigation?.route;
    const subRoutes = Array.isArray(route?.sub_routes) ? route.sub_routes : [];
    const allowedSubRoutes = subRoutes
      .map((subRoute) => filterNavigationsByPermissions([subRoute], userData)[0])
      .filter(Boolean);

    if (allowedSubRoutes.length > 0 || hasRoutePermission(route, permissionAccess)) {
      allowedNavigations.push({
        ...navigation,
        route: {
          ...route,
          sub_routes: allowedSubRoutes,
        },
      });
    }

    return allowedNavigations;
  }, []);
};

export default function DrawerComponent() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { listoggle, setListToggle, drawerShow, setDrawerShow, isMobileScreen } =
    useContext(ThemeContext);
  const [open, setOpen] = useState(true);

  const handleDrawerToggle = () => {
    setOpen(!open);
    setDrawerShow(!drawerShow);
  };
  const auth = useContext(AuthContext);
  let navigations = [
    {
      route: {
        main_routes: "Home",
        active_route: true,
        link: "/home",
        is_visible: true,
        icon: {
          main_icon: <AiOutlineDashboard className={Style?.icons} />,
        },
        sub_routes: [

        ],
      },
    },
    {
      route: {
        main_routes: "Quick Access",
        active_route: true,
        link: "/quick-access",
        is_visible: true,
        icon: {
          main_icon: <FaLink className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },
    {
      route: {
        main_routes: "Class Management",
        active_route: true,
        link: "/class-management",
        is_visible: true,
        icon: {
          main_icon: <TbCategoryFilled className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },
    {
      route: {
        main_routes: "Subject Management",
        active_route: true,
        link: "/subject-management",
        is_visible: true,
        icon: {
          main_icon: <TbCategoryFilled className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },
    {
      route: {
        main_routes: "Topics Management",
        active_route: true,
        link: "/topics-management",
        is_visible: true,
        icon: {
          main_icon: <TbCategoryFilled className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },
    {
      route: {
        main_routes: "Difficulty Level Management",
        active_route: true,
        link: "/difficulty-level-management",
        is_visible: true,
        icon: {
          main_icon: <TbCategoryFilled className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },
    {
      route: {
        main_routes: "Cohort Management",
        active_route: true,
        link: "/notification-cohort-management",
        is_visible: true,
        icon: {
          main_icon: <TbCategoryFilled className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },
    {
      route: {
        main_routes: "User Management",
        active_route: true,
        link: "/user-management",
        is_visible: true,
        icon: {
          main_icon: <FaAddressBook className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },
    {
      route: {
        main_routes: "Crowns and Badges",
        active_route: true,
        link: "/crowns-and-badges",
        is_visible: true,
        icon: {
          main_icon: <TbCategoryFilled className={Style?.icons} />,
        },
        sub_routes: []
      },
    },
    {
      route: {
        main_routes: "Learning",
        active_route: false,
        link: "/courses",
        is_visible: true,
        icon: {
          // main_icon: <HiMiniVideoCamera className={Style?.icons} />,
        },
        sub_routes: [
          {
            route: {
              main_routes: "Courses",
              active_route: true,
              link: "/courses",
              is_visible: true,
              icon: {
                main_icon: <HiMiniVideoCamera className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Short Videos",
              active_route: true,
              link: "/short-videos",
              is_visible: true,
              icon: {
                main_icon: <MdVideoLibrary className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Podcasts",
              active_route: true,
              link: "/podcasts",
              is_visible: true,
              icon: {
                main_icon: <FaMicrophone className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Webinars",
              active_route: true,
              link: "/webinars",
              is_visible: true,
              icon: {
                main_icon: <BsPersonVideo className={Style?.icons} />,
              },
              sub_routes: [],
            },
          }
        ],
      },
    },
    {
      route: {
        main_routes: "Engagement",
        active_route: false,
        link: "/manage-pages",
        is_visible: true,
        icon: {
          // main_icon: <SiPagespeedinsights className={Style?.icons} />,
        },
        sub_routes: [
          {
            route: {
              main_routes: "Sunday Polls",
              active_route: true,
              link: "/sunday-polls",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Quiz Management",
              active_route: true,
              link: "/quizzes",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Impact Stories",
              active_route: true,
              link: "/impact-stories-management",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Partners",
              active_route: true,
              link: "/partners-management",
              is_visible: true,
              icon: {
                main_icon: <FaMicrophone className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Competitions",
              active_route: true,
              link: "/competition",
              is_visible: true,
              icon: {
                main_icon: <BsPersonVideo className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Events",
              active_route: true,
              link: "/events",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
        ],
      },
    },
    {
      route: {
        main_routes: "Teacher Lounge",
        active_route: false,
        link: "/manage-post",
        is_visible: true,
        icon: {},
        sub_routes: [
          {
            route: {
              main_routes: "Posts",
              active_route: true,
              link: "/manage-post",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Flagged Post",
              active_route: true,
              link: "/manage-flagged-post",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Report Reason",
              active_route: true,
              link: "/report-reason",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
        ]
      }
    },
    {
      route: {
        main_routes: "Teaching kit",
        active_route: false,
        link: "/manage-pages",
        is_visible: true,
        icon: {
        },
        sub_routes: [
          {
            route: {
              main_routes: "Teaching Videos",
              active_route: true,
              link: "/teaching-videos",
              is_visible: true,
              icon: {
                main_icon: <MdVideoLibrary className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "School Processes",
              active_route: true,
              link: "/school-resource",
              is_visible: true,
              icon: {
                main_icon: <MdVideoLibrary className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "PBL",
              active_route: true,
              link: "/pbl-management",
              is_visible: true,
              icon: {
                main_icon: <FaMicrophone className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Holiday Homework",
              active_route: true,
              link: "/holiday-homework-management",
              is_visible: true,
              icon: {
                main_icon: <FaMicrophone className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Entry Exit",
              active_route: true,
              link: "/entry-exit-management",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "TLM",
              active_route: true,
              link: "/tlm-management",
              is_visible: true,
              icon: {
                main_icon: <FaMicrophone className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Question Bank",
              active_route: true,
              link: "/question-bank",
              is_visible: true,
              icon: {
                main_icon: <FaMicrophone className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Worksheet",
              active_route: true,
              link: "/worksheet-management",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Lesson Plan",
              active_route: true,
              link: "/lesson-plan-management",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "No Bag Activity",
              active_route: true,
              link: "/no-bag-activity-management",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Check Your Understanding",
              active_route: true,
              link: "/check-your-understanding-management",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Misconception",
              active_route: true,
              link: "/misconception-management",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Action Research",
              active_route: true,
              link: "/action-research-management",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
        ],
      },
    },
    {
      route: {
        main_routes: "Channel",
        active_route: false,
        link: "/channel-codes",
        is_visible: true,
        icon: {
          // main_icon: <HiMiniVideoCamera className={Style?.icons} />,
        },
        sub_routes: [
          {
            route: {
              main_routes: "Channel Types",
              active_route: true,
              link: "/channel-type",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Channel Codes",
              active_route: true,
              link: "/channel-code",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Channel",
              active_route: true,
              link: "/channel-list",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
          {
            route: {
              main_routes: "Channel Banner",
              active_route: true,
              link: "/channel-banner",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
        ],
      },
    },
    {
      route: {
        main_routes: "Survey",
        active_route: true,
        link: "/teacher-servey",
        is_visible: true,
        icon: {
          main_icon: <RiChatPollFill className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },
    {
      route: {
        main_routes: "CMS Pages",
        active_route: true,
        link: "/manage-pages",
        is_visible: true,
        icon: {
          main_icon: <SiPagespeedinsights className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },

    {
      route: {
        main_routes: "Analytics",
        active_route: true,
        link: "/get-analytics",
        is_visible: true,
        icon: {
          main_icon: <SiGoogleanalytics className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },
    {
      route: {
        main_routes: "FAQ Management",
        active_route: true,
        link: "/faq",
        is_visible: true,
        icon: {
          main_icon: <FaQuora className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },
    {
      route: {
        main_routes: "Support Management",
        active_route: true,
        link: "/support-management",
        is_visible: true,
        icon: {
          main_icon: <BiSupport className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },
    {
      route: {
        main_routes: "Subadmin Management",
        active_route: true,
        link: "/subadmin-management",
        is_visible: true,
        icon: {
          main_icon: <TbCategoryFilled className={Style?.icons} />,
        },
        sub_routes: [
        ],
      },
    },
    {
      route: {
        main_routes: "Roles Management",
        active_route: true,
        link: "/role-management",
        is_visible: true,
        icon: {
          main_icon: <TbCategoryFilled className={Style?.icons} />,
        },
        sub_routes: [
        ],
      },
    },
    {
      route: {
        main_routes: "Assign Channel",
        active_route: false,
        link: "/subadmin-management",
        is_visible: true,
        icon: {
          // main_icon: <TbCategoryFilled className={Style?.icons} />,
        },
        sub_routes: [
          {
            route: {
              main_routes: "Assign Channel",
              active_route: true,
              link: "/channeladmin-management",
              is_visible: true,
              icon: {
                main_icon: <RiChatPollFill className={Style?.icons} />,
              },
              sub_routes: [],
            },
          },
        ],
      },
    },
    {
      route: {
        main_routes: "Category Management",
        active_route: true,
        link: "/category-management",
        is_visible: true,
        icon: {
          main_icon: <TbCategoryFilled className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },

    {
      route: {
        main_routes: "Banners",
        active_route: true,
        link: "/banner",
        is_visible: true,
        icon: {
          main_icon: <FaImage className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },

    {
      route: {
        main_routes: "Manage Notifications",
        active_route: true,
        link: "/notifications",
        is_visible: true,
        icon: {
          main_icon: <TbNotification className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },
    {
      route: {
        main_routes: "Settings",
        active_route: true,
        link: "/settings",
        is_visible: true,
        icon: {
          main_icon: <IoSettings className={Style?.icons} />,
        },
        sub_routes: [],
      },
    },


  ];
  const visibleNavigations = filterNavigationsByPermissions(navigations, auth?.userData);

  const handleToggleMainMenu = (elem) => {
    setListToggle({
      ...listoggle,
      [elem?.route?.main_routes]: !listoggle[elem?.route?.main_routes],
    });
    if (elem?.route?.active_route) {
      navigate(elem?.route?.link);
    }
  };

  return (
    <>
      <Box className={drawerShow ? Style.open : Style.close}>
        <DrawerHeader sx={{ justifyContent: drawerShow ? 'flex-end' : 'center' }}>
          <IconButton
            color="inherit"
            onClick={handleDrawerToggle}
            sx={{ zIndex: 1, color: "white" }}
          >
            <MenuIcon />
          </IconButton>
        </DrawerHeader>
        <Box className={Style?.logo} onClick={() => navigate("/home")}>
          <img src={drawerShow ? LogoWhite : LogoWhiteMobile} alt="logo" />
        </Box>
        {visibleNavigations.map((elem, idx) => {
          if (auth?.userData?.is_subadmin) {
            return (
              <Box key={`${idx}-${elem?.route?.main_routes}`}>
                <Stack
                  className={
                    elem?.route?.active_route ?
                      pathname.includes(elem?.route?.link)
                        ? Style.navigation_selected
                        : Style.navigation_noselected
                      : Style.navigation_noselected}
                >
                  <Grid
                    onClick={() => handleToggleMainMenu(elem)}
                    container
                    className={Style.link_section}
                  >
                    <Grid item lg={2} md={2} sm={2}>
                      <Box ml={2}>{elem?.route?.icon?.main_icon}</Box>
                    </Grid>

                    <Grid item lg={8} md={8} sm={8}>

                      <Typography className={Style.title} style={{ display: "flex", }}>
                        {elem?.route?.main_routes}
                      </Typography>
                      <Collapse in={!!listoggle[elem.route.main_routes]} timeout="auto" unmountOnExit>
                        {elem?.route?.sub_routes.length ? (
                          elem.route.sub_routes.map((elem, idx) => {
                            return (
                              <Stack
                                className={
                                  pathname.includes(elem?.route?.link)
                                    ? Style.navigation_selected
                                    : Style.navigation_noselected
                                }
                                key={`${idx}-${elem?.route?.main_routes}`}
                              >
                                <Grid
                                  onClick={() => handleToggleMainMenu(elem)}
                                  container
                                  className={Style.link_section}
                                >
                                  <Grid item lg={2} md={2} sm={2}>
                                    <Box >
                                      {elem?.route?.icon?.main_icon}
                                    </Box>
                                  </Grid>

                                  <Grid item lg={8} md={8} sm={8}>
                                    <Typography className={Style.title}>
                                      {elem?.route?.main_routes}

                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Stack>
                            );
                          })
                        ) : (
                          null
                        )}
                      </Collapse>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>
            );
          } else if (auth?.userData?.is_superuser) {
            return (
              <Box key={`${idx}-${elem?.route?.main_routes}`}>
                <Stack
                  className={
                    elem?.route?.active_route ?
                      pathname.includes(elem?.route?.link)
                        ? Style.navigation_selected
                        : Style.navigation_noselected
                      : Style.navigation_noselected}
                >
                  <Grid
                    container
                    className={Style.link_section}
                    justifyContent={drawerShow && !isMobileScreen ? null : "center"}
                    textAlign={"center"}
                    gap={drawerShow && !isMobileScreen ? 0 : 2}
                  >
                    <Grid item lg={4} md={4} sm={12}
                      justifyItems={drawerShow ? null : "center"}
                      onClick={() => handleToggleMainMenu(elem)}
                    >
                      {elem?.route?.icon?.main_icon ? elem?.route?.icon?.main_icon : <>
                        {!!listoggle[elem.route.main_routes] ? <FaChevronUp className={Style?.icons} /> : <FaChevronDown className={Style?.icons} />}
                      </>}
                    </Grid>

                    <Grid item lg={8} md={8} sm={12}
                      justifyItems={drawerShow ? null : "center"}
                      sx={{ display: drawerShow ? "flex" : "none" }}
                      onClick={() => handleToggleMainMenu(elem)}
                    >

                      <Typography
                        className={Style.title}
                      >
                        {elem?.route?.main_routes}
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12}>
                      <Collapse in={!!listoggle[elem.route.main_routes]} timeout="auto" unmountOnExit>

                        {elem?.route?.sub_routes.length ? (
                          elem.route.sub_routes.map((elem, idx) => {
                            return (
                              <Stack
                                className={
                                  pathname.includes(elem?.route?.link)
                                    ? Style.navigation_selected
                                    : Style.navigation_noselected
                                }
                                key={`${idx}-${elem?.sub_routes?.main_routes}`}
                              >
                                <Grid
                                  onClick={() => handleToggleMainMenu(elem)}
                                  container
                                  className={Style.link_section}
                                  gap={drawerShow && !isMobileScreen ? 0 : 2}
                                  justifyContent="center"
                                >
                                  <Grid item lg={4} md={4} sm={12}
                                  >
                                    {elem?.route?.icon?.main_icon}
                                  </Grid>

                                  <Grid item lg={8} md={8} sm={12} sx={{ display: drawerShow ? "flex" : "none" }}>
                                    <Typography className={Style.title} >
                                      {elem?.route?.main_routes}

                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Stack>
                            );
                          })
                        ) : (
                          null
                        )}
                      </Collapse>
                    </Grid>
                  </Grid>
                </Stack>
              </Box>
            );
          } else {
            return null
          }
        })}
        {/* <NewDrawer/> */}
      </Box>
    </>
  );
}
